import React from 'react'
import { Modal, Button, Form, Select, Input, theme } from 'antd'
import { SwapOutlined, CloseOutlined } from '@ant-design/icons'
import { hexToRGBA } from '../../../../lib/utils'

const { Option } = Select

const TransferPatientModal = ({ isVisible, onCancel, onTransfer, form, selectedBed, wards }) => {
  const { token } = theme.useToken()

  return (
    <Modal
      title='Transfer Patient'
      visible={isVisible}
      onCancel={onCancel}
      footer={[
        <Button
          key='cancel'
          onClick={onCancel}
          icon={<CloseOutlined style={{ color: token.colorError }} />}
          style={{
            background: hexToRGBA(token.colorError, 0.1),
            borderColor: token.colorError,
            color: token.colorError
          }}
        >
          Cancel
        </Button>,
        <Button
          key='submit'
          onClick={onTransfer}
          icon={<SwapOutlined style={{ color: token.colorWarning }} />}
          style={{
            background: hexToRGBA(token.colorWarning, 0.1),
            borderColor: token.colorWarning,
            color: token.colorWarning,
            fontWeight: 'bold'
          }}
        >
          Transfer Patient
        </Button>
      ]}
    >
      <Form form={form} layout='vertical'>
        <Form.Item
          name='transferReason'
          label='Reason for Transfer'
          rules={[{ required: true, message: 'Please enter reason for transfer' }]}
        >
          <Input.TextArea rows={2} />
        </Form.Item>

        <Form.Item
          name='destinationWard'
          label='Destination Ward'
          rules={[{ required: true, message: 'Please select destination ward' }]}
        >
          <Select placeholder='Select ward'>
            {wards
              .filter((ward) => ward !== selectedBed?.ward)
              .map((ward) => (
                <Option key={ward} value={ward}>
                  {ward}
                </Option>
              ))}
          </Select>
        </Form.Item>

        <Form.Item
          name='destinationBed'
          label='Destination Bed'
          rules={[{ required: true, message: 'Please select destination bed' }]}
        >
          <Select placeholder='Select bed' disabled={!form.getFieldValue('destinationWard')}>
            {/* This would be dynamically populated based on selected ward */}
            <Option value='BED-110'>BED-110 (Available)</Option>
            <Option value='BED-111'>BED-111 (Available)</Option>
            <Option value='BED-113'>BED-113 (Available)</Option>
          </Select>
        </Form.Item>

        <Form.Item
          name='transferDateTime'
          label='Transfer Date/Time'
          rules={[{ required: true, message: 'Please specify transfer date/time' }]}
        >
          <Input type='datetime-local' />
        </Form.Item>
      </Form>
    </Modal>
  )
}

export default TransferPatientModal
